import React from 'react';
import { Alert } from 'antd';

export default class HealthInsuranceInformation extends React.Component {
	state = {
		CISIURL: 'http://www.semesteratsea.org/wp-content/uploads/2019/04/Semester-at-Sea_CISI-World-Class-Coverage-2019.pdf',//'http://www.semesteratsea.org/wp-content/uploads/2018/04/CISI_Semester-at-Sea_Health-Coverage-2018.pdf',
		medicalChecklistURL: 'http://www.semesteratsea.org/wp-content/uploads/2018/03/FA18-Medical-Clearance-Checklist.pdf'
	}
	render() {

		const fa18Form = 'http://www.semesteratsea.org/wp-content/uploads/2018/03/FA18-Travel-Medical-Concerns.pdf'
		const sp19Form = 'http://www.semesteratsea.org/wp-content/uploads/2018/08/SP-19-Travel-Medical-Concerns-062818.pdf?utm_source=hs_email&utm_medium=email&utm_content=65088273&_hsenc=p2ANqtz-_p-KmpDqBudMGSf7tP0tbLbPA3MJ9wRbYUX6CMw5RmyterWFBZ-V6JTf1dVVBN4IwnuIhBxc5hwM8Omr_ywnsz01HE3g&_hsmi=65088273'
		const fa19Form = 'http://www.semesteratsea.org/wp-content/uploads/2019/04/Semester-at-Sea_CISI-World-Class-Coverage-2019.pdf'
		if (this.props.variant !== 'admin' && this.props.redirectIfHidden) {
			const redirect = this.props.redirectIfHidden(this.props, 'health/info');
			if (redirect) return redirect;
		}

		return (
			<div>
				<Alert showIcon
					type="info"
					message={<span><a target="_blank" href={this.state.CISIURL}>Comprehensive Travel Health Insurance</a></span>} />
				<br />
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./portal-components/Portal/Health/HealthInsuranceInformation.jsx